export default __webpack_public_path__ + "static/communication-interface-2-5236722dddd7137fc8b13b4057fb80d5.jpeg";